import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { requestResumeSignup } from '../../services/stripeService';
import './AuthPages.css';

const ResumeSignupPage: React.FC = () => {
  const location = useLocation();
  const stateError = (location.state as { error?: string } | null)?.error;
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(stateError ?? null);

  useEffect(() => {
    if (stateError) setError(stateError);
  }, [stateError]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const url = await requestResumeSignup(email);
      window.location.assign(url);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Something went wrong');
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <img src="/dark_favicon_logo.png" alt="Gallop AI" className="auth-logo" />
          <h1>Resume signup</h1>
          <p>
            If you already paid at Stripe but did not finish creating your GallopAI account, enter the{' '}
            <strong>same email</strong> you used at checkout. We will send you back to registration.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="resume-email">Email (from Stripe checkout)</label>
            <input
              type="email"
              id="resume-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="you@example.com"
              autoComplete="email"
            />
          </div>

          <button type="submit" disabled={loading} className="auth-button primary">
            {loading ? 'Checking…' : 'Continue to register'}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            <Link to="/login" className="auth-link">
              Back to sign in
            </Link>
            {' · '}
            <Link to="/start-checkout/betfair" className="auth-link">
              Start free trial
            </Link>
            {' · '}
            <Link to="/" className="auth-link">
              Home
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResumeSignupPage;
